import {
    Activity,
    ActivityConstructorParams,
    IActivity,
    IActivityHost,
    OnNavigateOptions
} from "../ui/Activity";
import {Memo} from "../Memo";
import {app} from "../boot";
import {IDocument} from "../IMemoRemote";
import {registerClass} from "../Plugin";
import {DomWindow} from "../DomWindow";
import {slot} from "../lib/slot";
import {mkCtrlSeq} from "../util/DomUtils";


@registerClass(Activity.activityTypes)
export class MemoActivity extends Memo implements IActivity {
    static protocol = "memo";

    accessor parent: IActivityHost;

    constructor(params: ActivityConstructorParams) {
        super(
            null,
            app.selectionManager,
            null,
            undefined);
    }

    get url(): URL | null {
        return this.documentId ? new URL('memo:' + this.documentId) : null;
    }

    get title() {
        return (this.items?.meta?.props?.icon ? mkCtrlSeq('ICO', ''+this.items?.meta?.props?.icon) : '🗒️') + " " + (this.items?.meta?.props?.title || this.documentId);
    }

    async _onMetaUpdate(): Promise<void> {
        await super._onMetaUpdate();
        this.parent?.setTitle(this.title);
    }

    @slot(() => app, ($) => $.memoListRequested)
    onMemoListRequested() {
        return [ this ];
    }

    attachToHost(host: IActivityHost): void {
        this.parent = host;
        host?.setContent(this.scrollContainer);
        host?.setTitle(this.title);
        host?.setButtons([
            //DomWindow.makeButton('save', () => this.sendAll())
        ]);
        if (host) this.afterResize();
    }

    async initUI(): Promise<void> {
    }

    async navigate(document: string | IDocument, itemId:string|undefined, focus?: boolean, keepScrollPos?: boolean) {
        await this.parent.navigate(
            new URL("memo:" + (typeof document === 'string' ? document : document.documentId) + (itemId ? '#' + itemId : '')),
            { focus, keepScrollPos }
        );
    }

    async onNavigate(document: object, options: OnNavigateOptions): Promise<void> {
        console.log("MemoActivity.navigate", document, options);

        const oldScrollLeft = this.scrollContainer.scrollLeft, oldScrollTop = this.scrollContainer.scrollTop;
        if (document != this.document) {
            await this.setDocument(<IDocument>document);
            this.parent?.setTitle(this.title);
            await this.runAutostart();
        }
        const itemId = options.contentUrl?.hash?.substring(1);
        if (itemId) {
            this.jumpToItem(itemId, options.focus);
        } else if (options.keepScrollPos) {
            this.scrollContainer.scrollTo({behavior:'instant', left:oldScrollLeft, top:oldScrollTop});
        }
    }

    async onBeforeNavigate(url: URL, options: OnNavigateOptions): Promise<void> {
    }
    async onBeforeUnload(): Promise<void> {
    }

    afterResize(): void {
    }


}
